import { Config } from '@websky/core/src/context';
import { withConfig } from '@websky/core/src/config-hoc';
import { mountModule } from '@websky/core/src/__fsd__/shared/lib/mount-module';
import SearchForm from './SearchForm';
import { config as defaultConfig } from '../../config';
import merge from 'lodash.merge';

export const init = (mount: HTMLElement, config: Config): (() => void) => {
	const Component = withConfig(SearchForm, merge({}, defaultConfig, config));

	return mountModule(Component, mount);
};
